// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"8e438b3cad15e2d57432","655":"2b32286fe89a92cf717d"}[chunkId] + ".js";
};